let scoreRelaxationExempt = false;
let scoreRelaxationYear = null;

export function setDpatScoreRelaxationExempt(value) {
  scoreRelaxationExempt = Boolean(value);
}

export function isDpatScoreRelaxationExempt() {
  return scoreRelaxationExempt;
}

export function getDpatRelaxationYear() {
  return scoreRelaxationYear;
}

export function syncDpatScoreRelaxation(isExempt, year) {
  setDpatScoreRelaxationExempt(Boolean(isExempt));
  const yearNum = Number(year);
  scoreRelaxationYear = Number.isFinite(yearNum) ? yearNum : scoreRelaxationYear;
  return scoreRelaxationExempt;
}

function resolveRelaxationYear(year) {
  const yearNum = Number(year ?? scoreRelaxationYear);
  return Number.isFinite(yearNum) ? yearNum : null;
}

/** Meeting / incident / AAP / timeline years: assessment year and prior year (e.g. 2025 and 2024). */
export function getDpatIncidentYears(selectedYear) {
  const year = resolveRelaxationYear(selectedYear);
  if (year == null) return [];
  return [year - 1, year];
}

/** Tracker registration years: assessment year and next year (e.g. 2025 and 2026). */
export function getDpatRegistrationYears(selectedYear) {
  const year = resolveRelaxationYear(selectedYear);
  if (year == null) return [];
  return [year, year + 1];
}

export function isDpatIncidentYear(yearValue, selectedYear) {
  const year = Number(yearValue);
  return Number.isFinite(year) && getDpatIncidentYears(selectedYear).includes(year);
}

export function isDpatRegistrationYear(yearValue, selectedYear) {
  const year = Number(yearValue);
  return Number.isFinite(year) && getDpatRegistrationYears(selectedYear).includes(year);
}

function readRecordYearAttribute(record) {
  const attributes = record?.attributes || [];
  const match = attributes.find((attribute) => {
    const name = String(attribute?.displayName || "").trim().toLowerCase();
    return name === "year" || name === "select year" || name === "dpat | year" || name === "years";
  });
  return match?.value
    ?? attributes.find((attribute) => attribute?.attribute === "Ik7fouv4KOA")?.value
    ?? attributes.find((attribute) => attribute?.attribute === "pWkYqcKukAY")?.value
    ?? "";
}

export function filterRecordsByDpatYearAttribute(records, selectedYear) {
  const allowed = new Set(
    (isDpatScoreRelaxationExempt()
      ? getDpatIncidentYears(selectedYear)
      : [Number(selectedYear)].filter(Number.isFinite)
    ).map(String),
  );
  return (records || []).filter((record) => allowed.has(String(readRecordYearAttribute(record))));
}

export function dpatRelaxedTrackerStartDate(year) {
  const yearNum = resolveRelaxationYear(year);
  if (scoreRelaxationExempt && yearNum != null) {
    return `${yearNum - 1}-01-01`;
  }
  return `${year}-01-01`;
}

export function dpatRelaxedTrackerEndDate(year) {
  const yearNum = resolveRelaxationYear(year);
  if (scoreRelaxationExempt && yearNum != null) {
    return `${yearNum + 1}-12-31`;
  }
  return `${year}-12-31`;
}

function rewriteUrlDateWindow(url, yearNum) {
  if (!url || yearNum == null) return url;
  const start = `${yearNum - 1}-01-01`;
  const end = `${yearNum + 1}-12-31`;
  return String(url)
    .replace(/([?&]startDate=)\d{4}-\d{2}-\d{2}/g, `$1${start}`)
    .replace(/([?&]endDate=)\d{4}-\d{2}-\d{2}/g, `$1${end}`)
    .replace(/([?&]filter=pe:)\d{4}-\d{2}-\d{2}/g, `$1${start}`);
}

export function applyDpatScoreRelaxationToAxiosConfig(config) {
  if (!config || !scoreRelaxationExempt) return config;

  const yearNum = resolveRelaxationYear();
  if (yearNum == null) return config;

  if (config.url) {
    config.url = rewriteUrlDateWindow(config.url, yearNum);
  }

  if (config.params && typeof config.params === "object") {
    if (typeof config.params.startDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(config.params.startDate)) {
      config.params.startDate = `${yearNum - 1}-01-01`;
    }
    if (typeof config.params.endDate === "string" && /^\d{4}-\d{2}-\d{2}$/.test(config.params.endDate)) {
      config.params.endDate = `${yearNum + 1}-12-31`;
    }
  }

  return config;
}
